import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import images from "../../Data/images";

const Locations = () => {
  return (
    <div className="text-gray-800">

      {/* Header */}
      <div className="bg-[#c4122f] py-12 px-6 md:px-20 text-white">
        <h1 className="text-3xl font-bold">LOCATIONS</h1>
        <p className="text-lg mt-2">
          Professional Security Services Across Ontario
        </p>
      </div>

      {/* Breadcrumb */}
      <div className="flex justify-between items-center py-4 px-6 md:px-20 border-b">
        <span className="text-sm text-gray-500">HOME / LOCATIONS</span>
        <span className="flex items-center gap-2 text-sm text-gray-700">
          <FaPhoneAlt className="text-[#c4122f]" />
          +1 (416) 477-7692
        </span>
      </div>

      {/* Intro */}
      <section className="py-16 px-6 md:px-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-3xl font-bold text-[#c4122f] mb-4">
            Professional Security Services Across Ontario
          </h2>

          <p className="mb-4">
            Argus Security International provides professional security
            services for businesses, residential communities, construction
            projects, and private clients across Ontario.
          </p>

          <p className="mb-4">
            Our teams deliver reliable security solutions supported by trained
            personnel, modern technology, and strong operational standards.
          </p>

          <p>
            Whether you require uniformed security guards, mobile patrol
            services, parking enforcement, or technology-based security
            solutions, Argus is ready to support your property and security
            needs.
          </p>
        </div>

        <img
          src={images.s5}
          alt="Security Services"
          className="rounded-xl shadow-lg"
        />
      </section>

      {/* Primary Service Areas */}
      <section className="py-16 px-6 md:px-20 bg-gray-50">
        <h2 className="text-3xl font-bold text-[#c4122f] mb-6">
          Primary Service Areas
        </h2>

        <p className="mb-6">
          Argus Security provides security services in major cities and
          surrounding regions including:
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            "Toronto",
            "Mississauga",
            "Brampton",
            "Vaughan",
            "Markham",
            "Richmond Hill",
            "Scarborough",
            "North York",
            "Oakville",
            "Burlington",
            "Hamilton",
            "Barrie",
            "Oshawa",
            "Pickering",
            "Ajax",
            "Whitby",
          ].map((city) => (
            <div
              key={city}
              className="bg-white shadow-sm border rounded-lg py-3 px-4 text-center hover:shadow-md transition"
            >
              {city}
            </div>
          ))}
        </div>

        <p className="mt-6 text-gray-600">
          Our teams also support projects and clients throughout the Greater
          Toronto Area and surrounding regions.
        </p>
      </section>

      {/* Services Available */}
      <section className="py-16 px-6 md:px-20 grid md:grid-cols-2 gap-10">
        <div>
          <h2 className="text-3xl font-bold text-[#c4122f] mb-6">
            Security Services Available in These Locations
          </h2>

          <ul className="list-disc list-inside space-y-2">
            <li>Uniformed Security Guards</li>
            <li>Mobile Patrol Services</li>
            <li>Construction Site Security</li>
            <li>Parking Enforcement</li>
            <li>Concierge Security</li>
            <li>Gatehouse Security</li>
            <li>CCTV & Access Control Installation</li>
            <li>Fire Watch Security</li>
            <li>Loss Prevention</li>
            <li>Executive Protection</li>
          </ul>
        </div>

        <div>
          <h2 className="text-3xl font-bold text-[#c4122f] mb-6">
            Serving Businesses, Properties, and Communities
          </h2>

          <ul className="list-disc list-inside space-y-2">
            <li>Commercial Office Buildings</li>
            <li>Residential & Condominium Communities</li>
            <li>Construction Sites</li>
            <li>Retail Locations</li>
            <li>Industrial Facilities</li>
            <li>Events and Private Functions</li>
          </ul>
        </div>
      </section>

      {/* Map */}
      <section className="py-16 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-bold text-[#c4122f] mb-4">
          Service Coverage Map
        </h2>

        <div className="w-full h-[400px] rounded-xl overflow-hidden shadow">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2883.970366561617!2d-79.653288!3d43.7111649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3c0634378905%3A0x1637666d9090318a!2sArgus%20Security%20Intl!5e0!3m2!1sen!2sin!4v1743007941539!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
          ></iframe>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-[#c4122f] text-white text-center">
        <h2 className="text-2xl font-semibold mb-4">
          Request Security Services in Your Area
        </h2>

        <p className="mb-6">
          Argus Security International is ready to support your property with
          professional security services.
        </p>

        <p className="font-semibold text-lg mb-2">📞 416-477-7692</p>
        <p className="mb-6">🌐 www.argussecurity.ca</p>

        <a
          href="/contact"
          className="bg-white text-[#c4122f] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
        >
          CONTACT US
        </a>
      </section>

    </div>
  );
};

export default Locations;